import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { FORBIDDEN } from "_constants/PageRoutes";
import { useAuthContextUser } from "../context/AuthContext";
import AdminLayout from "../layout/AdminLayout";
import {
  AdminOnlyRouteToComponent,
  IsSifManagerRouteToComponent,
  IsSuperAdminOnlyRouteToComponent,
  IsSuperAdminOrLibAdminRouteToComponent,
  IsSuperAdminORLibAdminWithReportingExportRouteToComponent,
  IsSuperAdminOrLibManagerRouteToComponent,
  IsSuperAdminOrToolsAndLibAdminRouteToComponent,
} from "../_constants/AuthenticatedRouteToComponent";

const AdminRoute = (props) => {
  const user = useAuthContextUser();
  const isSuperAdmin = user && user.isSuperAdmin;
  const isToolsAndLibAdmin = user && user.isToolsAndLibAdmin;
  const isStoreAdmin = user && user.isStoreAdmin;
  const isLibraryManager = user && user.isLibraryManager;
  const isSifManager = user && user.isSifManager;
  const isToolsAndLibAdminWithReportingEntitlement = isToolsAndLibAdmin && user.hasReportingExport

  return (
    <AdminLayout>
      <Switch>
        {AdminOnlyRouteToComponent &&
          AdminOnlyRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
        {(isSuperAdmin || isToolsAndLibAdminWithReportingEntitlement) &&
          IsSuperAdminORLibAdminWithReportingExportRouteToComponent &&
          IsSuperAdminORLibAdminWithReportingExportRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
        {isSuperAdmin &&
          IsSuperAdminOnlyRouteToComponent &&
          IsSuperAdminOnlyRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
        {(isSuperAdmin || isToolsAndLibAdmin) &&
          IsSuperAdminOrLibAdminRouteToComponent &&
          IsSuperAdminOrLibAdminRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
        {(isSuperAdmin || isLibraryManager) &&
          IsSuperAdminOrLibManagerRouteToComponent &&
          IsSuperAdminOrLibManagerRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
        {(isSuperAdmin || isToolsAndLibAdmin) &&
          IsSuperAdminOrToolsAndLibAdminRouteToComponent &&
          IsSuperAdminOrToolsAndLibAdminRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
        {(isSuperAdmin || isSifManager) &&
          IsSifManagerRouteToComponent &&
          IsSifManagerRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
        <Redirect to={FORBIDDEN} />
      </Switch>
    </AdminLayout>
  );
};

export default AdminRoute;
